import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  @Input() allowDecimal = false;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const e = event as KeyboardEvent;
    if (
      ['Backspace','Tab','End','Home','ArrowLeft','ArrowRight','Delete'].includes(e.key) ||
      (e.ctrlKey || e.metaKey)
    ) return;

    const isNumber = /[0-9]/.test(e.key);
    if (isNumber) return;

    if (this.allowDecimal && (e.key === '.' || e.key === ',')) {
      const target = e.target as HTMLInputElement;
      if (target && !target.value.includes('.')) return;
    }

    e.preventDefault();
  }
}

//Usage: <input appOnlyNumber [allowDecimal]="true">


